import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';
import { singularize } from 'ember-inflector';

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
let RoleCheckerService = (_class = class RoleCheckerService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "notify", _descriptor4, this);
    _initializerDefineProperty(this, "log", _descriptor5, this);
  }
  checkPermissions(meId, transition, checkSuffix = '_view') {
    if (!meId) return false;
    const me = this.store.peekRecord('contact', meId);
    if (!me) return false;
    return this._checkMe(me, transition, checkSuffix);
  }
  _checkMe(me, transition, checkSuffix) {
    const giorniRimanenti = me.organization?.subscription?.giorni_rimanenti;
    if (!giorniRimanenti || giorniRimanenti <= 0) {
      const routeToTransition = me.organization_admin ? 'settings.plan' : 'locked';
      // Never redirect the recovery route to itself: settings.plan (admin) and
      // locked (non-admin) ARE the expired-subscription destinations. Re-issuing
      // the transition while we're already entering it aborts and re-enters the
      // transition forever (infinite reload on the subscription page).
      if (transition?.to?.name === routeToTransition) {
        return false;
      }
      this.router.transitionTo(routeToTransition).catch(e => this.log.warn('[role-checker] transitionTo aborted:', routeToTransition, e));
      return false;
    }
    return this._checkRole(me, transition, checkSuffix);
  }
  _checkRole(me, transition, checkSuffix) {
    const roleField = this._determineRoleField(transition, checkSuffix);
    if (!roleField) return false;
    const hasPermission = Boolean(me?.role?.[roleField]);
    if (!hasPermission) {
      this._handlePermissionError();
      return false;
    }
    return true;
  }
  _determineRoleField(transition, suffix) {
    const params = transition?.to?.params;
    const modelName = params?.model_name;
    if (!modelName) return null;
    let singular = singularize(modelName);
    if (['contract', 'receipt', 'ddt', 'order', 'autofattura'].includes(singular)) {
      singular = 'invoice';
    }
    return `${singular}${suffix}`;
  }
  _handlePermissionError() {
    this.notify.warning(this.intl.t('insufficient permissions'));
    this.router.transitionTo('/').catch(e => this.log.warn('[role-checker] transitionTo / aborted (insufficient permissions):', e));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "notify", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "log", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { RoleCheckerService as default };
//# sourceMappingURL=role-checker.js.map
